import { render, staticRenderFns } from "./schooldata.vue?vue&type=template&id=4a827a40&scoped=true"
import script from "./schooldata.vue?vue&type=script&lang=js"
export * from "./schooldata.vue?vue&type=script&lang=js"
import style0 from "./schooldata.vue?vue&type=style&index=0&id=4a827a40&prod&lang=css"
import style1 from "./schooldata.vue?vue&type=style&index=1&id=4a827a40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a827a40",
  null
  
)

export default component.exports